<template>
  <div class='serie-item flex flex-col xl:grid gap-2 xl:gap-6 xl:grid-cols-2'>
    <template v-if="serie">
      <div class="serie-item-image">
        <div class="relative w-full aspect-[916/423] overflow-hidden rounded-8px">
          <a :href="serie.link" class="w-full h-full">
            <img
              v-lazy="serie.banner_xs.x3.url"
              :alt="serie.title"
              @load="imageLoaded = true"
              :class="['w-full h-full object-cover', { 'opacity-0': !imageLoaded }]"
            />
          </a>
        </div>
      </div>
      <div class="serie-item-info flex flex-col xl:justify-center p-4 xl:py-0">
        <div v-if="serie.serie_tag_list?.length > 1" class="serie-item-tags mb-4">
          <div class="flex flex-wrap gap-2">
            <span v-for='tag in randomTags' :key="tag" class="inline-block px-2.5 leading-6 rounded-[24px] text-14px text-orange-200 bg-gray-500 capitalize">
              {{ tag }}
            </span>
          </div>
        </div>

        <div class="serie-item-title text-18px sm:text-20px font-medium leading-6 sm:leading-7">
          {{ serie.title }}
        </div>

        <div class="serie-item-content mt-2 text-16px text-gray-150 leading-6 break-all line-clamp-3"
            :class="{ 'xl:line-clamp-2 2xl:line-clamp-4': serie.serie_tag_list?.length == 0, 'xl:line-clamp-1 2xl:line-clamp-3': serie.serie_tag_list?.length > 0 }">
          {{ serie.content }}
        </div>

        <div class="serie-item-metrics mt-6 mb-4 flex items-center gap-2">
          <div class="view-count flex items-center gap-1">
            <div
              class="w-4 h-4 bg-gray-100"
              :style="{
                WebkitMask: `url(${viewCountIcon}) no-repeat center/contain`,
                mask: `url(${viewCountIcon}) no-repeat center/contain`
              }"
              aria-label="view count"
            ></div>

            <div class="text-14px text-gray-100 font-medium leading-4">
              {{ formatViewsCount(serie.views_count) }}
            </div>
          </div>
          <div class="likes-count flex items-center gap-1">
            <div
              class="w-4 h-4 bg-gray-100"
              :style="{
                WebkitMask: `url(${likesIcon}) no-repeat center/contain`,
                mask: `url(${likesIcon}) no-repeat center/contain`
              }"
              aria-label="like count"
            ></div>
            <div class="text-14px text-gray-100 font-medium leading-4">
              {{ formatViewsCount(serie.likes_count) }}
            </div>
          </div>
          <div class="downloads-count flex items-center gap-1">
            <div
              class="w-4 h-4 bg-gray-100"
              :style="{
                WebkitMask: `url(${downloadIcon}) no-repeat center/contain`,
                mask: `url(${downloadIcon}) no-repeat center/contain`
              }"
              aria-label="download count"
            ></div>
            <div class="text-14px text-gray-100 font-medium leading-4">
              {{ formatViewsCount(serie.downloads_count) }}
            </div>
          </div>
        </div>

        <div v-if="serie.profiles.length > 0" class="serie-community flex flex-col sm:flex-row sm:items-center gap-2">
          <div class="flex items-center">
            <template v-for="(profile, index) in serie.profiles.slice(0, 3)">
              <div class="w-8 h-8 border-2 border-bg-base rounded-full overflow-hidden" :class="{ '-ml-4': index > 0 }">
                <img :src="profile.avatar_url" alt="profile avatar" class="w-full h-full">
              </div>
            </template>
          </div>
          <div class="text-14px leading-[22px]">
            {{ $t('series.index.community_talking')}}
          </div>
        </div>
        <div v-else class="serie-community flex flex-col sm:flex-row sm:items-center gap-2">
          <div v-if="current_profile" class="w-8 h-8 border-2 border-bg-base rounded-full overflow-hidden">
            <img :src="current_profile.avatar_url" alt="profile avatar" class="w-full h-full">
          </div>

          <div class="text-14px leading-[22px]">
            {{ $t('series.index.explore_community')}}
          </div>
        </div>

        <div class="serie-item-button mt-8">
          <a :href="serie.link" class="inline-block text-14px md:text-16px text-gray-150 font-medium leading-5 md:leading-6 py-2 px-8 rounded-[24px] border-2 border-gray-150 hover:bg-gray-300">
            {{ $t('series.index.view_collection')}}
          </a>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Skeleton screen -->
      <div class="skeleton-card">
        <div class="skeleton-image h-40 bg-grey-300"></div>
        <div class="skeleton-data-container p-4">
          <div class="skeleton-title h-6 bg-grey-300 mb-2"></div>
          <div class="skeleton-metrics flex justify-between">
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import viewCountIcon from '../../images/icons/view-count.svg'
import likesIcon from '../../images/icons/likes.svg'
import downloadIcon from '../../images/icons/download.svg'

export default defineComponent({
  props: {
    serie: {
      type: Object,
      required: true
    },
    current_profile: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      imageLoaded: false,
      viewCountIcon,
      likesIcon,
      downloadIcon,
      randomTags: []
    }
  },
  created() {
    if (this.serie && this.serie.serie_tag_list) {
      this.randomTags = [...this.serie.serie_tag_list].sort(() => Math.random() - 0.5).slice(0, 3);
    }
  },
  methods: {
    formatViewsCount(count) {
      return new Intl.NumberFormat().format(count);
    }
  }
});
</script>